import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../utils/analytics'

const ScrollToTop = () => {
  const { pathname, search } = useLocation()

  useEffect(() => {
    // Use requestAnimationFrame for smoother scroll
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    })
    
    // Track page view in Google Analytics (defer to avoid blocking)
    const fullPath = pathname + search
    // Use setTimeout to defer analytics tracking
    const timeoutId = setTimeout(() => {
      trackPageView(fullPath, document.title)
    }, 0)

    return () => clearTimeout(timeoutId)
  }, [pathname, search])

  return null
}

export default ScrollToTop
















